<template>
<div class="nj-input-upload">
    <div class="nj-label">{{ label }}</div>
    <div>
        <b-upload v-model="document" @input="input($event)">
            <div class="nj-button">
                <span class="nj-text-ellipsis">{{ name }}</span>
            </div>
        </b-upload>
        <Button title="Remover adjunto" color="red" icon="delete" v-if="document" @click="remove()"></Button>
    </div>
</div>
</template>
<script>
export default {
    name: "InputUpload",
    components: {

    },
    props: {
        value: null,
        label: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "Adjuntar"
        },
    },
    data() {
        return {
            document: null
        }
    },
    watch: {
        value(newValue) {
            this.document = newValue
        }
    },
    computed: {
        name() {
            if (this.document) {
                return this.document.name
            }
            else {
                return this.text
            }
        }
    },
    methods: {
        input(document) {
            this.$emit("input", document)
        },
        remove() {
            this.document = null
            this.$emit("input", this.document)
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.nj-input-upload {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}
</style>